import { moduleProviderFactory } from 'core/providers';
import { ImportReferenceEdit, ImportReferenceList, ImportReferenceUpload } from 'application/import-reference/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.import-reference',
                pattern: '/import-references',
                children: [
                    {
                        name: 'master.app.main.import-reference.list',
                        pattern: '',
                        tabTitle: 'IMPORT_REFERENCE.LIST.TITLE_SECONDARY',
                        component: ImportReferenceList,
                        data: {
                            title: 'IMPORT_REFERENCE.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: 'master.app.main.import-reference.create',
                        pattern: '/create',
                        tabTitle: 'Create Reference',
                        component: ImportReferenceEdit,
                        authorization: 'importReferenceSection.create',
                        data: {
                            title: 'IMPORT_REFERENCE.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.import-reference.upload',
                        pattern: '/upload',
                        tabTitle: 'IMPORT_REFERENCE.UPLOAD.TITLE',
                        component: ImportReferenceUpload,
                        authorization: 'importReferenceSection.create',
                        data: {
                            title: 'IMPORT_REFERENCE.UPLOAD.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.import-reference.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Reference',
                        component: ImportReferenceEdit,
                        authorization: 'importReferenceSection.update',
                        data: {
                            title: 'IMPORT_REFERENCE.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.FACILITY_ORDERS',
                order: 5,
                icon: 'package',
                authorization: 'coreUserSection.read',
                subMenu: [
                    {
                        title: 'MENU.IMPORT_REFERENCES_SUB',
                        route: 'master.app.main.import-reference.list',
                        order: 8,
                    }                    
                ]
            }
        ]
    });
})();
